export const KAFKA_AUTH_USER_TOKEN = "KAFKA_AUTH_USER_TOKEN";
export const KAFKA_AUTH_USER_DATA = "KAFKA_AUTH_USER_DATA";
